import type { ChangelogAdvancedPayload } from "./changelog-advanced.model";

/** Structured changelog for Snoots PMS v1.43.42 (advanced template). */
export const CHANGELOG_ADVANCED_PAYLOAD_V143_42: ChangelogAdvancedPayload = {
  omitTabNavigation: true,
  titleKey: "changelog.advanced.title",
  subtitleKey: "changelog.advanced.subtitle.v14342",
  brandKey: "changelog.advanced.brand.pms",
  helpCenterLabelKey: "changelog.advanced.helpCenter",
  helpCenterUrl: "https://helpcenter.snoots.pet/",
  footnoteKey: "changelog.advanced.footer.v14342",
  stats: [
    {
      value: 1,
      labelKey: "changelog.advanced.stat.printRelease",
      accentColor: "#0F6E56"
    }
  ],
  tabs: [
    {
      id: "stampa",
      labelKey: "changelog.advanced.tab.print",
      count: 1,
      accentColor: "#185FA5",
      kind: "video",
      youtubeVideoId: "LGjTXfUEpZg",
      videoHeadingKey: "changelog.advanced.v14342.video.heading",
      videoCaptionKey: "changelog.advanced.v14342.video.caption",
      youtubeOpenLabelKey: "changelog.advanced.v14342.video.openYoutube",
      bulletsAfterVideoLabelKey:
        "changelog.advanced.v14342.video.detailsHeading",
      items: [
        {
          textKey: "changelog.advanced.v14342.print.1"
        }
      ]
    }
  ]
};
